import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';

import { CallTo, MailTo } from 'components/common';

const ContactUs = ({ about }) => {
  return (
    <div className="row mb-30">
      <div className="col-15">
        <h2 className="h5">Sorularınız İçin Bize Ulaşın</h2>
      </div>
      <div className="col-15">
        <div className="mb-2">
          Çağrı Merkezi:
          {' '}
          <CallTo tel="+90 (850) 885 46 25" />
        </div>
        <div className="mb-2">
          E-Posta:
          {' '}
          <MailTo mail="info@iyimakina.com" />
        </div>
        <div>
          {about}
          {' '}
          ilgili daha fazla bilgi için
          {' '}
          <Link href="/faq/buyers">
            <a>Sıkça Sorulan Sorular</a>
          </Link>
          'ı inceleyebilirsiniz.
        </div>
      </div>
    </div>
  );
};

ContactUs.propTypes = {
  about: PropTypes.string,
};

export default ContactUs;
